import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AcceptedInvitationResponse } from '../../models/invitation-response.model';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-application-approved',
  templateUrl: './application-approved.component.html',
  styleUrl: './application-approved.component.scss'
})
export class ApplicationApprovedComponent implements OnInit {
  private readonly router = inject(Router);
  public data: AcceptedInvitationResponse | null;
  public readonly loginUrl = `${environment.commandCenterUrl}/login`;

  constructor() {
    const navigation = this.router.getCurrentNavigation();
    this.data = navigation?.extras?.state as AcceptedInvitationResponse ?? null;
  }

  public ngOnInit(): void {
    // Auto-navigate after 3 seconds
    setTimeout(() => {
      this.navigateToLogin();
    }, 3000);
  }

  public navigateToLogin(): void {
    window.location.href = this.loginUrl;
  }
}
